'use strict';
export function Notifications() {
  if($('.headline').length>0){
    function zeroPadding(num, length) {
      return ('0000000000' + num).slice(-length);
    }

    $.ajax({
      type: "GET",
      url: 'https://payvent.net/wp-json/wp/v2/posts?per_page=4'
    }).done((data) => {
      if (data != null) {
        $.each(data, function(index, entry){
          var date = new Date(entry.date)
          var dateStr = 'YYYY-MM-DD';
          dateStr = dateStr.replace(/YYYY/g, date.getFullYear());
          dateStr = dateStr.replace(/MM/g, zeroPadding(date.getMonth() + 1, 2));
          dateStr = dateStr.replace(/DD/g, zeroPadding(date.getDate(), 2));
          $('.headline').append(`<div><span>${dateStr}</span><a href='${entry.guid.rendered}' target='_blank'>${entry.title.rendered}</a></div>`);
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./app/javascript/packs/notifications.js